import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";

// reactstrap components
import {
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
} from "reactstrap";

import * as actions from "../../store/actions/index";
import ProfilePageHeader from "../../Components/Headers/ProfilePageHeader";
import DefaultFooter from "../../Components/Footers/DefaultFooter";
import LandingPageNavbar from "../../Components/Navbars/LandingPageNavbar";
import StravaActivities from "../../Containers/Strava/StravaActivities";
import Event from "../Event/Event";
import MyActivities from "..//MyActivies/MyActivities";
import ScrollTransparentNavbar from "../../Components/Navbars/ScrollTransparentNavbar";

function ProfilePage(props) {
  const [pills, setPills] = useState("1");
  const [isLoading, setIsLoading] = useState(true);
  const [activities, setActivities] = useState({ items: [] });

  useEffect(() => {
    document.body.classList.add("profile-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("profile-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  useEffect(() => {
    // console.log("selected item", localStorage.getItem("test"));
    const access_token = localStorage.getItem("access_token");

    if (access_token) {
      props.onGetStravaAthlete(access_token);
    }
  }, []);

  return (
    <>
      <ScrollTransparentNavbar />
      <div className="wrapper">
        <ProfilePageHeader athlete={props.athlete} />

        <div className="section">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto" md="6">
                <h4 className="title text-center">My Portfolio</h4>
                <div className="nav-align-center">
                  <Nav
                    className="nav-pills-info nav-pills-just-icons"
                    pills
                    role="tablist"
                  >
                    <NavItem>
                      <NavLink
                        className={pills === "1" ? "active" : ""}
                        href="#pablo"
                        onClick={(e) => {
                          e.preventDefault();
                          setPills("1");
                        }}
                      >
                        <i className="now-ui-icons ui-1_calendar-60"></i>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={pills === "2" ? "active" : ""}
                        href="#pablo"
                        onClick={(e) => {
                          e.preventDefault();
                          setPills("2");
                        }}
                      >
                        <i className="now-ui-icons tech_watch-time"></i>
                      </NavLink>
                    </NavItem>
                    {/* <NavItem>
                      <NavLink
                        className={pills === "3" ? "active" : ""}
                        href="#pablo"
                        onClick={(e) => {
                          e.preventDefault();
                          setPills("3");
                        }}
                      >
                        <i className="now-ui-icons sport_user-run"></i>
                      </NavLink>
                    </NavItem> */}
                  </Nav>
                </div>
              </Col>
              <TabContent className="gallery" activeTab={"pills" + pills}>
                <TabPane tabId="pills1">
                  <Event />
                </TabPane>
                <TabPane tabId="pills2">
                  <MyActivities />
                </TabPane>
                {/* <TabPane tabId="pills3">
                  <StravaActivities />
                </TabPane> */}
              </TabContent>
            </Row>
          </Container>
        </div>
        <DefaultFooter />
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    athlete: state.strava.athlete,
    profileImage: state.strava.profileImage,
    firstName: state.strava.firstName,
    lastName: state.strava.lastName,
    city: state.strava.city,
    activities: state.strava.activities,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetStravaAuthCode: (authCode, refresh_token, tokenExpired) =>
      dispatch(
        actions.getStravaAuthCode(authCode, refresh_token, tokenExpired)
      ),
    onGetStravaActivities: (access_token) =>
      dispatch(actions.getStravaActivities(access_token)),
    onGetStravaAthlete: (access_token) =>
      dispatch(actions.getStravaAthlete(access_token)),
    // onAuthCheckState: () => dispatch(actions.authCheckState()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage);
